import Vue from "vue"

import evaButton from "@/components/shared/basic/EvaButton.vue"

Vue.component("EvaButton", evaButton)
